<h3 [style.color]="color">
  {{ title }}
</h3>

<div [style.background]="color"></div>
